import axios from 'api/axios'
import { Enquiry } from 'types'

export interface GetEnquiriesOptions {
	page: number
	size: number
	broadcast: string
}

export interface GetEnquiriesResponse {
	totalCount: number
	records: Array<Enquiry>
	totalPages: number
	currentPage: number
}

const getEnquiries = async (
	params: GetEnquiriesOptions
): Promise<GetEnquiriesResponse> => {
	const response = await axios.get(
		'v1/enquiry/management/broadcast-enquiry-details',
		{
			params,
		}
	)

	return response.data
}

export default getEnquiries
